







































import CFMDialog from '@/scripts/CFMDialog'
import {Component} from 'vue-property-decorator';

import * as blockui from '@/helpers/block-ui'

import {required} from "vuelidate/lib/validators";

import {CFMDTOContinent } from '@/scripts/services/ClientApiAuto'

@Component<ContinentDialog>({
    validations() {
        return {
          continent:{
              Name: {required}
          }
        }
    },
})
export default class ContinentDialog extends CFMDialog {
    continent: CFMDTOContinent = {Name: ''};

    async created(){
      blockui.blockModal(this);
      if(this.isUpdate){
        const res = await this.apiClient.continent.continentGetById({id: <number>this.id});
        console.log(res);
        this.continent = res.data;
      }
      blockui.unBlockModal();
    }

    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
          return;
      }
      let formData = {
        Id: this.continent.Id,
        Name: this.continent.Name,
      };
      blockui.blockModal(this);
      try{
        const response  = await this.apiClient.continent.continentSave(formData);
        if (response.data.IsSuccess) {
          toastr.success(this.translate('save_successfully'));
          this.saveSucceeded();
          this.close();
        } else {
          const errorMessage = response.data.Message ? response.data.Message : "Error";
          toastr.error(errorMessage);
        }
      }
      catch(e){
        console.log("err",e)
        toastr.error(e);
      }
      finally{
        blockui.unBlockModal();
      }
    }
}
